// extracted by mini-css-extract-plugin
module.exports = {"goals_list":"styles_goals_list__3do8w"};